import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

//   fromDate,
//   pageNumber = 1,
//   pageSize = 20,
//   toDate,
//   userId,
//   groupId,
//   reportMode
// ) => {
//   cancelToken = getAxiosCancelToken(cancelToken);

//   if (reportMode === "View") {
//     return apiRequestType(
//       apiTypes.GET,
//       apiConstants.REPORT.ACCESS_REPORT.GET_ACCESS_REPORT(
//         fromDate,
//         (pageNumber = 1),
//         (pageSize = 20),
//         toDate,
//         userId,
//         groupId,
//         reportMode
//       ),
//       "",
//       cancelToken
//     );
//   } else {
//     let url =
//       encodeURIComponent(apiConstants.BASE_URL_1) +
//       encodeURIComponent(
//         apiConstants.REPORT.ACCESS_REPORT.GET_ACCESS_REPORT(
//           fromDate,
//           (pageNumber = 1),
//           (pageSize = 20),
//           toDate,
//           userId,
//           groupId,
//           reportMode
//         )
//       );
//     let template = "QuizPerformanceReport";
//     return apiRequestType(
//       apiTypes.GET,
//       apiConstants.REPORT.CSV_REPORT(url, template),
//       "",
//       cancelToken
//     );
//   }
// };

const getAccessReport = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.REPORT.ACCESS_REPORT.GET_ACCESS_REPORT,
    data
  );
};

export default getAccessReport;
